import React from "react";
import {
  BannerImageWrapper,
  BannerNashvillePromoContainer,
  BannerNashvillePromoContent,
  BrandButton,
  PrimaryButton,
  Subtitle,
  TextContentContainer,
  Title
} from "./styles";
import { useMedia } from "react-use";
import { mediaQuery, Text } from "@hubble/web";
import NextImage from "components/parts/NextImage";
import { contentfulLoader } from "utils/images/contentfulLoader";
import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import FloatingQRCode from "../FloatingQRCode";
import { Link } from "i18n/routing";

const RenderCTA = () => {
  const t = useTranslations(FILES.COMMON);
  const isMobile = useMedia(mediaQuery.mobileXsDown, false);
  if (!isMobile) {
    return (
      <BrandButton
        size="lg"
        href="https://exchange.gemini.com/register?referral=Welcome10&type=referral"
        target="_blank"
      >
        {t("bannerNashVillePromo.getStarted")}
      </BrandButton>
    );
  } else {
    return (
      <PrimaryButton
        size="md"
        href="https://geminiexchange.app.link/ugvtBBYWiAb"
        target="_blank"
      >
        {t("bannerNashVillePromo.downloadApp")}
      </PrimaryButton>
    );
  }
};

const getImageSpecs = (
  isMobile: boolean
): {
  src: string;
  height: number;
  width: number;
} => {
  return isMobile
    ? {
        src: "//images.ctfassets.net/jg6lo9a2ukvr/4Xzhc9CMyMcrJgBJgcerJT/50aeafd5c3f966ea142ce138ee1ade91/Group_2147212332__1_.png",
        height: 307,
        width: 555
      }
    : {
        src: "//images.ctfassets.net/jg6lo9a2ukvr/5ZRwNzcLQD1Zqkq96s5kNf/b1751a81e151f66bcdf0032936195d5b/Group_2147212332.png",
        height: 555,
        width: 1000
      };
};

const BannerNashvillePromo = () => {
  const isMobile = useMedia(mediaQuery.mobileXsDown, false);
  const t = useTranslations(FILES.COMMON);

  return (
    <React.Fragment>
      <FloatingQRCode />
      <BannerNashvillePromoContainer>
        <BannerNashvillePromoContent flexDirection="column">
          <TextContentContainer flexDirection="column">
            <Title
              size="xl"
              mb={isMobile ? 1 : 2}
              align={isMobile ? "left" : "center"}
            >
              {t("bannerNashVillePromo.title")}
              <span>bitcoin</span>
            </Title>
            <Subtitle marketing size="xs" mb={3}>
              {t("bannerNashVillePromo.subTitleP1")} <span>Welcome10</span>{" "}
              {t("bannerNashVillePromo.subTitleP2")}
            </Subtitle>
            <RenderCTA />
            <Text.Link
              mt={2}
              as={Link}
              href="/legal/gemini-new-user-incentive-program-terms"
              target="_blank"
            >
              <Text.Body size="xs">
                {t("bannerNashVillePromo.termsApply")}
              </Text.Body>
            </Text.Link>
          </TextContentContainer>
          <BannerImageWrapper>
            <NextImage
              alt="Gemini homepage hero image"
              loader={contentfulLoader}
              {...getImageSpecs(isMobile)}
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "1000px"
              }}
            />
          </BannerImageWrapper>
        </BannerNashvillePromoContent>
      </BannerNashvillePromoContainer>
    </React.Fragment>
  );
};

export default BannerNashvillePromo;
